import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StaticAssets } from './static-assets.interface';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StaticAssetsService {

    constructor(private http: HttpClient) { }

    getStaticResources<T = any>(url: StaticAssets): Observable<T> {
        const { staticAssets } = environment.staticScripts;
        return this.http.get<T>(`${staticAssets}json/${url}`);
    }
}
